export default {
  baseurl: process.env.VUE_APP_BASE_URL,
};
